(() => {
  if (customElements.get('regalux-lazy-featured-collection')) return;

  class RegaluxLazyFeaturedCollection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.regaluxInitialized === 'true') return;

      this.dataset.regaluxInitialized = 'true';
      this.retryButton = this.querySelector('[data-regalux-lazy-retry]');
      this.statusElement = this.querySelector('[data-regalux-lazy-status]');
      this.loadSection = this.loadSection.bind(this);
      this.retryButton?.addEventListener('click', this.loadSection);

      if (!('IntersectionObserver' in window)) {
        this.loadSection();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.observer.disconnect();
          this.loadSection();
        },
        {
          rootMargin: '1200px 0px',
          threshold: 0
        }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.retryButton?.removeEventListener('click', this.loadSection);
    }

    async loadSection() {
      if (this.dataset.regaluxState === 'loading') return;

      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      this.dataset.regaluxState = 'loading';
      this.setAttribute('aria-busy', 'true');
      this.retryButton?.setAttribute('hidden', '');

      if (this.statusElement) {
        this.statusElement.textContent = 'Se încarcă produsele…';
      }

      try {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.set('section_id', sectionId);

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Shopify Section Rendering API: ${response.status}`);
        }

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = parsedDocument.getElementById(`shopify-section-${sectionId}`);
        const currentSection = this.closest(`#shopify-section-${sectionId}`);

        if (
          !nextSection ||
          !currentSection ||
          nextSection.querySelector('[data-regalux-lazy-featured-collection]')
        ) {
          throw new Error('Shopify did not return the complete featured collection.');
        }

        currentSection.replaceWith(nextSection);

        nextSection.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId }
          })
        );

        document.dispatchEvent(
          new CustomEvent('regalux:lazy-featured-collection:loaded', {
            detail: { sectionId, element: nextSection }
          })
        );
      } catch (error) {
        this.dataset.regaluxState = 'error';
        this.setAttribute('aria-busy', 'false');

        if (this.statusElement) {
          this.statusElement.textContent = 'Produsele nu s-au putut încărca.';
        }

        this.retryButton?.removeAttribute('hidden');
        console.error('[Regalux] Lazy featured collection:', error);
      }
    }
  }

  customElements.define(
    'regalux-lazy-featured-collection',
    RegaluxLazyFeaturedCollection
  );
})();
